import { render, staticRenderFns } from "./sendSMS.vue?vue&type=template&id=746fe775"
import script from "./sendSMS.ts?vue&type=script&lang=js&external"
export * from "./sendSMS.ts?vue&type=script&lang=js&external"
import style0 from "./sendSMS.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports